module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gc_layer_off-9664296ebd9e815d5e6008a403e4b3a3.png";